/* Boosted Engineering theme scripts */
(function () {
  'use strict';

  var money = function (value) {
    var n = parseFloat(value);
    if (isNaN(n)) { return ''; }
    return '$' + n.toLocaleString('en-AU', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  };
  var moneyCents = function (cents) { return money(cents / 100); };

  /* ---------- Day / Night toggle ---------- */
  var root = document.documentElement;
  var themeBtn = document.querySelector('[data-be-theme]');
  var themeLabel = document.querySelector('[data-be-theme-label]');
  function syncThemeLabel() {
    if (themeLabel) { themeLabel.textContent = root.getAttribute('data-theme') === 'dark' ? window.beT('gen.day', "Day") : window.beT('gen.night', "Night"); }
  }
  syncThemeLabel();
  if (themeBtn) {
    themeBtn.addEventListener('click', function () {
      var next = root.getAttribute('data-theme') === 'dark' ? 'light' : 'dark';
      root.setAttribute('data-theme', next);
      try { localStorage.setItem('be-theme', next); } catch (e) {}
      syncThemeLabel();
    });
  }

  /* ---------- Dropdown menu ---------- */
  document.querySelectorAll('[data-be-drop]').forEach(function (btn) {
    var drop = btn.parentNode.querySelector('.be-drop');
    btn.addEventListener('click', function (e) {
      e.stopPropagation();
      var open = !drop.classList.contains('is-open');
      drop.classList.toggle('is-open', open);
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
    document.addEventListener('click', function (e) {
      if (!btn.parentNode.contains(e.target)) {
        drop.classList.remove('is-open');
        btn.setAttribute('aria-expanded', 'false');
      }
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { drop.classList.remove('is-open'); btn.setAttribute('aria-expanded', 'false'); }
    });
  });

  /* ---------- Live search ---------- */
  var searchBox = document.querySelector('[data-be-search]');
  if (searchBox) {
    var input = searchBox.querySelector('[data-be-search-input]');
    var clear = searchBox.querySelector('[data-be-search-clear]');
    var results = searchBox.querySelector('[data-be-search-results]');
    var timer = null;
    var seq = 0;

    var searchUrl = function (q) {
      return '/search?type=product&q=' + encodeURIComponent(q);
    };

    var render = function (items, q) {
      results.innerHTML = '';
      if (!items.length) {
        var none = document.createElement('div');
        none.className = 'be-search__none';
        none.textContent = window.beT('search.no_match_yet', "No matches yet. Try another word.");
        results.appendChild(none);
        return;
      }
      items.forEach(function (p) {
        var a = document.createElement('a');
        a.className = 'be-search__row';
        a.href = p.url;
        var name = document.createElement('span');
        name.textContent = p.title;
        var price = document.createElement('span');
        price.textContent = money(p.price);
        a.appendChild(name);
        a.appendChild(price);
        results.appendChild(a);
      });
      var all = document.createElement('a');
      all.className = 'be-search__row be-search__all';
      all.href = searchUrl(q);
      var allLabel = document.createElement('span');
      allLabel.textContent = window.beT('search.view_all', "View all results for") + ' "' + q + '"';
      all.appendChild(allLabel);
      results.appendChild(all);
    };

    var onlyRelevant = function (items, q) {
      var words = q.toLowerCase().split(/\s+/).filter(Boolean);
      if (words.length < 2) { return items; }
      var hit = items.filter(function (p) {
        var t = (p.title || '').toLowerCase();
        return words.every(function (w) { return t.indexOf(w) !== -1; });
      });
      return hit.length ? hit : items;
    };

    var run = function (q) {
      var id = ++seq;
      fetch('/search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=10&resources[options][unavailable_products]=last')
        .then(function (r) { return r.json(); })
        .then(function (data) {
          if (id !== seq) { return; }
          var items = (data && data.resources && data.resources.results && data.resources.results.products) || [];
          render(onlyRelevant(items, q).slice(0, 6), q);
        })
        .catch(function () { if (id === seq) { render([], q); } });
    };

    input.addEventListener('input', function () {
      var q = input.value.trim();
      searchBox.classList.toggle('has-q', q.length > 0);
      clearTimeout(timer);
      if (!q) { results.innerHTML = ''; return; }
      timer = setTimeout(function () { run(q); }, 200);
    });
    input.addEventListener('keydown', function (e) {
      if (e.key === 'Enter') {
        e.preventDefault();
        var q = input.value.trim();
        if (q) { window.location.href = searchUrl(q); }
      }
    });
    clear.addEventListener('click', function () {
      input.value = '';
      searchBox.classList.remove('has-q');
      results.innerHTML = '';
      input.focus();
    });
    document.addEventListener('click', function (e) {
      if (!searchBox.contains(e.target)) { searchBox.classList.remove('has-q'); }
      else if (input.value.trim()) { searchBox.classList.add('has-q'); }
    });
  }

  /* ---------- Cart count ---------- */
  function setCartCount(n) {
    document.querySelectorAll('[data-be-cart-count]').forEach(function (el) {
      el.textContent = n;
      if (n > 0) { el.removeAttribute('hidden'); } else { el.setAttribute('hidden', ''); }
    });
  }

  /* ---------- Vehicle finder ---------- */
  var finder = document.querySelector('[data-be-finder]');
  if (finder) {
    var V = {
      'Toyota': { '86': ['GT', 'GR'], 'Supra': ['GR'] },
      'Subaru': { 'BRZ': ['ZC6', 'ZD8'], 'WRX': ['VA', 'VB'] },
      'BMW': {
        '1 Series': ['F20', 'F21'],
        '2 Series': ['F22', 'F23', 'G42'],
        '3 Series': ['F30', 'F31', 'F34', 'G20', 'G21'],
        '4 Series': ['F32', 'F33', 'F36', 'G22', 'G23', 'G26'],
        '5 Series': ['G30', 'G31'],
        '6 Series': ['G32'],
        '7 Series': ['G11', 'G12'],
        '8 Series': ['G14', 'G15', 'G16'],
        'X3': ['G01'], 'X4': ['G02'], 'X5': ['G05'], 'X6': ['G06'], 'X7': ['G07'],
        'M2': ['F87', 'F87 - Competition', 'G87'],
        'M3': ['F80', 'G80', 'G81'],
        'M4': ['F82', 'F83', 'G82', 'G83'],
        'M5': ['F90'],
        'M8': ['F91', 'F92', 'F93'],
        'X5 M': ['F95'],
        'X6 M': ['F96']
      }
    };
    var selMake = finder.querySelector('[data-be-make]');
    var selModel = finder.querySelector('[data-be-model]');
    var selGen = finder.querySelector('[data-be-gen]');
    var fill = function (sel, placeholder, list) {
      sel.innerHTML = '';
      var o = document.createElement('option');
      o.value = ''; o.textContent = placeholder;
      sel.appendChild(o);
      list.forEach(function (item) {
        var opt = document.createElement('option');
        opt.value = item; opt.textContent = item;
        sel.appendChild(opt);
      });
    };
    fill(selMake, window.beT('finder.select_make', "Select make"), Object.keys(V));
    fill(selModel, window.beT('finder.select_model', "Select model"), []);
    fill(selGen, window.beT('finder.select_gen', "Select generation"), []);
    selMake.addEventListener('change', function () {
      fill(selModel, window.beT('finder.select_model', "Select model"), selMake.value ? Object.keys(V[selMake.value]) : []);
      fill(selGen, window.beT('finder.select_gen', "Select generation"), []);
    });
    selModel.addEventListener('change', function () {
      fill(selGen, window.beT('finder.select_gen', "Select generation"), selMake.value && selModel.value ? V[selMake.value][selModel.value] : []);
    });
    finder.querySelector('[data-be-go]').addEventListener('click', function () {
      var parts = [];
      var gen = selGen.value ? selGen.value.split(' - ')[0] : '';
      if (selMake.value === 'BMW' && gen) {
        parts.push(gen);
      } else {
        if (selModel.value) { parts.push(selModel.value); }
        if (gen) { parts.push(gen); }
      }
      if (!parts.length && selMake.value) { parts.push(selMake.value); }
      if (!parts.length) { return; }
      window.location.href = '/search?type=product&q=' + encodeURIComponent(parts.join(' '));
    });
  }

  /* ---------- Product page ---------- */
  var prod = document.querySelector('[data-be-product]');
  if (prod) {
    /* The product's own variant data is a direct child of the product block.
       (Other widgets on the page, like the bundle box, carry their own data.) */
    var variantsEl = prod.querySelector(':scope > [data-be-variants]') || prod.querySelector('[data-be-variants]');
    var variants = JSON.parse(variantsEl.textContent);
    var form = prod.querySelector('[data-be-form]');
    var idInput = form.querySelector('[name="id"]');
    var priceEl = prod.querySelector('[data-be-price]');
    var compareEl = prod.querySelector('[data-be-compare]');
    var btn = prod.querySelector('[data-be-add]');
    var msg = prod.querySelector('[data-be-msg]');
    var qtyInput = prod.querySelector('[data-be-qty]');
    var mainImg = prod.querySelector('.be-gal__main img');

    /* The main photo is rendered with srcset/sizes, which override src.
       Clear them so the swapped photo actually shows. */
    var setMain = function (src) {
      if (!mainImg || !src) { return; }
      mainImg.removeAttribute('srcset');
      mainImg.removeAttribute('sizes');
      mainImg.src = src;
    };

    var selectedOptions = function () {
      var out = [];
      form.querySelectorAll('fieldset[data-be-option]').forEach(function (fs) {
        var checked = fs.querySelector('input:checked');
        out.push(checked ? checked.value : null);
        var label = fs.querySelector('[data-be-option-value]');
        if (label && checked) { label.textContent = checked.value; }
      });
      return out;
    };
    var findVariant = function (opts) {
      for (var i = 0; i < variants.length; i++) {
        var v = variants[i], ok = true;
        for (var j = 0; j < opts.length; j++) { if (v.options[j] !== opts[j]) { ok = false; break; } }
        if (ok) { return v; }
      }
      return null;
    };
    var update = function () {
      var v = findVariant(selectedOptions());
      if (!v) {
        btn.disabled = true; btn.textContent = window.beT('product.choose_other', "Choose another option");
        return;
      }
      idInput.value = v.id;
      priceEl.textContent = moneyCents(v.price);
      if (compareEl) {
        if (v.compare_at_price && v.compare_at_price > v.price) {
          compareEl.textContent = moneyCents(v.compare_at_price); compareEl.hidden = false;
        } else { compareEl.hidden = true; }
      }
      btn.disabled = false;
      btn.textContent = window.beT('product.add_to_cart', "Add to cart");
      try {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', url.toString());
      } catch (e) {}
    };
    var lastVariantImage = null;
    form.addEventListener('change', function (e) {
      if (e.target.closest('fieldset[data-be-option]')) {
        update();
        var v = findVariant(selectedOptions());
        var src = v && v.featured_image && v.featured_image.src;
        if (src && src !== lastVariantImage) { lastVariantImage = src; setMain(src); }
      }
    });
    update();

    /* quantity */
    prod.querySelector('[data-be-qty-minus]').addEventListener('click', function () {
      qtyInput.value = Math.max(1, (parseInt(qtyInput.value, 10) || 1) - 1);
    });
    prod.querySelector('[data-be-qty-plus]').addEventListener('click', function () {
      qtyInput.value = Math.min(99, (parseInt(qtyInput.value, 10) || 1) + 1);
    });

    /* gallery */
    var thumbs = Array.prototype.slice.call(prod.querySelectorAll('[data-be-thumb]'));
    thumbs.forEach(function (t) {
      t.addEventListener('click', function () {
        setMain(t.getAttribute('data-src'));
        thumbs.forEach(function (o) { o.classList.remove('is-on'); });
        t.classList.add('is-on');
      });
    });

    /* gallery arrows + swipe */
    var mainBox = prod.querySelector('.be-gal__main');
    if (mainBox && thumbs.length > 1) {
      var css = document.createElement('style');
      css.textContent = '.be-gal__arrow{position:absolute;top:50%;transform:translateY(-50%);width:44px;height:44px;border-radius:50%;border:0;background:rgba(255,255,255,.88);color:#111;display:flex;align-items:center;justify-content:center;cursor:pointer;box-shadow:0 2px 10px rgba(0,0,0,.25);z-index:3;padding:0;transition:background .15s,transform .15s}.be-gal__arrow:hover{background:#fff}.be-gal__arrow:active{transform:translateY(-50%) scale(.94)}.be-gal__arrow--prev{left:12px}.be-gal__arrow--next{right:12px}.be-gal__arrow svg{width:20px;height:20px}[data-theme="dark"] .be-gal__arrow{background:rgba(20,20,20,.85);color:#fff}[data-theme="dark"] .be-gal__arrow:hover{background:#000}@media(max-width:600px){.be-gal__arrow{width:38px;height:38px}}';
      document.head.appendChild(css);

      var step = function (dir) {
        var i = 0;
        thumbs.forEach(function (t, idx) { if (t.classList.contains('is-on')) { i = idx; } });
        var n = (i + dir + thumbs.length) % thumbs.length;
        thumbs[n].click();
        if (thumbs[n].scrollIntoView) { try { thumbs[n].scrollIntoView({ block: 'nearest', inline: 'nearest' }); } catch (e) {} }
      };
      var mk = function (dir, label, path) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'be-gal__arrow be-gal__arrow--' + (dir < 0 ? 'prev' : 'next');
        b.setAttribute('aria-label', label);
        b.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="' + path + '"/></svg>';
        b.addEventListener('click', function (e) { e.preventDefault(); step(dir); });
        mainBox.appendChild(b);
      };
      mk(-1, window.beT('product.prev_photo', "Previous photo"), 'M15 18l-6-6 6-6');
      mk(1, window.beT('product.next_photo', "Next photo"), 'M9 6l6 6-6 6');

      var sx = null;
      mainBox.addEventListener('touchstart', function (e) { sx = e.touches[0].clientX; }, { passive: true });
      mainBox.addEventListener('touchend', function (e) {
        if (sx === null) { return; }
        var dx = e.changedTouches[0].clientX - sx;
        sx = null;
        if (Math.abs(dx) > 40) { step(dx < 0 ? 1 : -1); }
      }, { passive: true });
    }

    /* add to cart */
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (btn.disabled) { return; }
      var label = btn.textContent;
      btn.disabled = true; btn.textContent = window.beT('product.adding', "Adding...");
      msg.textContent = '';
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: parseInt(idInput.value, 10), quantity: parseInt(qtyInput.value, 10) || 1 })
      })
        .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, body: j }; }); })
        .then(function (res) {
          if (!res.ok) { throw new Error(res.body.description || res.body.message || window.beT('product.add_error', 'Could not add to cart')); }
          btn.textContent = window.beT('product.added', "Added to cart");
          msg.innerHTML = window.beT('product.added_short', "Added.") + ' <a href="/cart" style="text-decoration:underline">' + window.beT('product.view_cart', "View cart") + '</a>';
          return fetch('/cart.js').then(function (r) { return r.json(); }).then(function (c) { setCartCount(c.item_count); });
        })
        .catch(function (err) {
          msg.textContent = err.message;
          btn.textContent = label;
        })
        .then(function () {
          setTimeout(function () { btn.disabled = false; update(); }, 1500);
        });
    });
  }

  /* ---------- Collection sort ---------- */
  var sort = document.querySelector('[data-be-sort]');
  if (sort) {
    sort.addEventListener('change', function () {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', sort.value);
      url.searchParams.delete('page');
      window.location.href = url.toString();
    });
  }
})();

/* ---------- Hero video autoplay safeguard ---------- */
document.querySelectorAll('.be-hero__video').forEach(function (v) {
  try { v.muted = true; v.defaultMuted = true; var p = v.play(); if (p && p.catch) { p.catch(function () {}); } } catch (e) {}
});
